import Lara from "@/presets/lara";

const dropdownDefaultPt = Lara.dropdown;

export const statusSelectPt = {
  root: ({ props }: { props: { disabled?: boolean } }) => ({
    class: [
      "inline-flex relative items-center select-none",
      "h-9 rounded-full border pl-3.5 pr-3",
      "transition-all duration-200",
      props.disabled
        ? "bg-gray-125 border-gray-175 cursor-not-allowed"
        : "bg-white border-gray-475 cursor-pointer hover:brightness-[0.97]",
    ],
  }),
  input: {
    class: [
      "flex flex-auto items-center",
      "bg-transparent border-0 p-0",
      "whitespace-nowrap",
      "focus:outline-none focus:shadow-none",
      "appearance-none",
    ],
  },
  trigger: {
    class: ["flex items-center justify-center shrink-0", "bg-transparent text-indigo-base", "w-6"],
  },
  panel: {
    class: [
      "absolute top-0 left-0 mt-2",
      "min-w-[248px] p-2",
      "bg-white border border-gray-200 rounded-[14px]",
      "shadow-[0_14px_34px_rgba(30,38,76,0.16)]",
    ],
  },
  wrapper: {
    class: ["max-h-[300px] overflow-auto"],
  },
  list: {
    class: "p-0 m-0 list-none",
  },
  item: ({ context }: { context: { focused: boolean } }) => ({
    class: [
      "flex items-center w-full m-0 px-3 py-2.5",
      "rounded-[9px] border-0",
      "text-sm font-bold text-indigo-base",
      "cursor-pointer overflow-hidden whitespace-nowrap",
      "hover:bg-gray-125",
      { "bg-gray-125": context.focused },
    ],
  }),
  transition: dropdownDefaultPt.transition,
};
